import { T, TEAM_NAMES } from "../tokens";
import { frameToClock } from "./matchClock";

export default function TopBar({
  frames, currentIdx,
  activeView, setActiveView, scenarios,
  onRunSimulation, simulating,
  onToggleUpload, showUploadPanel,
  selectedMode, usingDemo, allRows, poseLoaded, poseMap,
  showHeatmap, setShowHeatmap, showTrails, setShowTrails, showPose, setShowPose,
  handleTrackingFile, handlePoseFile,
}) {
  const clock = frames.length ? frameToClock(frames[currentIdx] ?? 0) : "0:00";

  return (
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",
      padding:"10px 16px",borderBottom:`1px solid ${T.border}`,background:T.surface,flexWrap:"wrap",gap:8}}>

      {/* Left: brand + match title */}
      <div style={{display:"flex",alignItems:"center",gap:14}}>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <span style={{fontSize:18}}>⚽</span>
          <div style={{fontWeight:800,fontSize:13,letterSpacing:0.4,color:T.textPri,whiteSpace:"nowrap"}}>
            PBMP Football Scenario Workbench
          </div>
        </div>
        <div style={{width:1,height:20,background:T.border}}/>
        <div style={{fontSize:12,color:T.textSec,whiteSpace:"nowrap"}}>
          {TEAM_NAMES[0]} <span style={{color:T.textDim}}>vs</span> {TEAM_NAMES[1]}
        </div>
        <div style={{display:"flex",alignItems:"center",gap:5,fontSize:12,color:T.textPri,
          background:T.panel,border:`1px solid ${T.border}`,borderRadius:6,padding:"3px 9px"}}>
          <span>⏱</span>{clock}
        </div>
      </div>

      {/* Center: Actual Match / Scenario pills */}
      <div style={{display:"flex",gap:6,alignItems:"center"}}>
        <button onClick={()=>setActiveView("actual")} style={pillStyle(activeView==="actual", T.accent)}>
          Actual Match
        </button>
        {scenarios.map(sc=>(
          <button key={sc.id} onClick={()=>setActiveView(sc.id)}
            style={pillStyle(activeView===sc.id, sc.color)}>
            <span style={{width:7,height:7,borderRadius:"50%",background:sc.color,display:"inline-block",marginRight:6}}/>
            {sc.label}
          </button>
        ))}
      </div>

      {/* Right: data controls + actions */}
      <div style={{display:"flex",gap:6,alignItems:"center",flexWrap:"wrap"}}>
        {[
          ["🔥 Heatmap", showHeatmap, ()=>setShowHeatmap(v=>!v)],
          ["〰 Trails",  showTrails,  ()=>setShowTrails(v=>!v)],
          ["🦴 Pose",    showPose,    ()=>setShowPose(v=>!v), selectedMode!=="FULL"],
        ].map(([lbl,active,fn,disabled])=>(
          !disabled && <button key={lbl} onClick={fn} style={{
            background:active?`${T.accent}22`:T.panel,
            border:`1px solid ${active?T.accent:T.border}`,
            borderRadius:6,color:active?T.accent:T.textSec,
            padding:"5px 10px",cursor:"pointer",fontSize:11,fontFamily:"inherit"}}>
            {lbl}
          </button>
        ))}

        <label style={{background:T.panel,border:`1px solid ${T.border}`,borderRadius:6,
          padding:"5px 10px",fontSize:11,cursor:"pointer",color:T.accent,fontFamily:"inherit"}}>
          📂 tracking.csv
          <input type="file" accept=".csv" onChange={handleTrackingFile} style={{display:"none"}}/>
        </label>
        {selectedMode==="FULL" && <label style={{
          background:poseLoaded?`${T.accent}22`:T.panel,
          border:`1px solid ${poseLoaded?T.accent:T.border}`,
          borderRadius:6,padding:"5px 10px",fontSize:11,cursor:"pointer",
          color:poseLoaded?T.accent:T.textSec,fontFamily:"inherit"}}>
          🦴 pose.csv
          <input type="file" accept=".csv" onChange={handlePoseFile} style={{display:"none"}}/>
        </label>}

        <div style={{width:1,height:20,background:T.border}}/>

        <button
          onClick={onRunSimulation}
          disabled={activeView==="actual"||simulating}
          title={activeView==="actual"?"Select a scenario to simulate":"Run heuristic outcome estimate for this scenario"}
          style={{
            background: activeView==="actual" ? "#1E2733" : T.accent,
            border:"none",borderRadius:6,color:"#fff",
            padding:"6px 14px",cursor:activeView==="actual"?"not-allowed":"pointer",
            fontSize:11,fontWeight:700,fontFamily:"inherit",
            opacity: activeView==="actual" ? 0.5 : 1,
            display:"flex",alignItems:"center",gap:6,
          }}>
          ▶ {simulating ? "Simulating…" : "Run Simulation"}
        </button>
        <button onClick={onToggleUpload} style={{
          background:showUploadPanel?`${T.accent}22`:T.panel,
          border:`1px solid ${showUploadPanel?T.accent:T.border}`,
          borderRadius:6,color:showUploadPanel?T.accent:T.textPri,
          padding:"6px 11px",cursor:"pointer",fontSize:11,fontFamily:"inherit",fontWeight:600}}>
          🎬 Analyze Match
        </button>
        <button style={ghostBtn}>💾 Save</button>
        <button style={ghostBtn}>⇪ Export</button>
        <button style={ghostBtn}>⚙ Settings</button>
      </div>
    </div>
  );
}

function pillStyle(active, color) {
  return {
    background: active ? `${color}22` : "transparent",
    border: `1px solid ${active ? color : "transparent"}`,
    borderRadius: 999, color: active ? color : "#7A8FA6",
    padding: "5px 12px", cursor: "pointer", fontSize: 11,
    fontFamily: "inherit", fontWeight: active ? 700 : 500,
    display: "flex", alignItems: "center", whiteSpace: "nowrap",
  };
}

const ghostBtn = {
  background: T.panel, border: `1px solid ${T.border}`, borderRadius: 6,
  color: T.textSec, padding: "6px 11px", cursor: "pointer",
  fontSize: 11, fontFamily: "inherit",
};
